<script setup lang="ts">
import IconButton from "~/components/IconButton.vue";
import { useProfileStore } from "~/store";
import type { Org } from "~/common/types/types";
import ImportProfileFromUrlModal from "./ImportProfileFromUrlModal.vue";
const isModalOpen = ref(false);

async function submitted(url: string) {
  await useProfileStore().importUrl(props.org._id, url);
  isModalOpen.value = false;
}

const props = defineProps({
  org: {
    type: Object as PropType<Org>,
      required: true,
    },  
  });

</script>

<template>
    <div>
        <IconButton @click="isModalOpen = true">Import from URL</IconButton>
        <ImportProfileFromUrlModal
            v-if="isModalOpen"
            @close="isModalOpen = false"
            @submitted="submitted"
        />
    </div>
</template>